module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "content expo"
  }, [_c('div', {
    staticClass: "expo-head"
  }, [_c('div', {
    staticClass: "expo-head-text"
  }, [_vm._v("Show us your own project or job!")]), _vm._v(" "), _c('div', {
    staticClass: "expo-head-button"
  }, [_c('button', {
    staticClass: "button is-twitter",
    on: {
      "click": _vm.tweet
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "twitter"
    }
  }), _vm._v(" "), _c('span', [_vm._v("#MadeWithBuefy")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline"
  }, _vm._l((_vm.expo), function(item, i) {
    return _c('div', {
      key: item.title,
      staticClass: "column has-text-centered",
      class: i % 3 ? 'is-half' : 'is-full',
      staticStyle: {
        "padding-right": "2.5em"
      }
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('img', {
      staticClass: "image-has-shadow",
      attrs: {
        "src": _vm.getImg(item.img),
        "alt": item.title
      }
    })]), _vm._v(" "), _c('p', [_c('a', {
      staticClass: "title is-5",
      attrs: {
        "href": item.url,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_vm._v("\n                        " + _vm._s(item.title) + "\n                    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "subtitle is-6"
    }, [_vm._v("\n                        " + _vm._s(new Date(item.date).toLocaleDateString()) + "\n                    ")])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf612b2e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/Expo.vue
// module id = 1301
// module chunks = 8